<template>
  <span>
    <!--
      "Llamar orden": trae una cita en curso con todo lo que la clienta ya
      consumio, en vez de teclearlo de nuevo en caja. La orden de trabajo no es
      una entidad aparte: es la CITA a la que el staff le fue sumando consumos
      desde el check-in.
    -->
    <button type="button" class="btn btn-outline-primary pos-tap" :class="{ 'btn-success text-white': store.booking_id }" @click="openModal">
      <i class="fa-solid fa-receipt me-1" aria-hidden="true"></i>
      <span v-if="store.booking_id">{{ $t('pos.lbl_order_loaded', { id: store.booking_id }) }}</span>
      <span v-else>{{ $t('pos.lbl_call_order') }}</span>
    </button>

    <PosModal v-model="show" :title="$t('pos.lbl_open_orders')" :close-label="$t('pos.lbl_close')">
      <AlertMessage v-if="error" :message="error" />

      <p class="text-muted small mb-2">{{ $t('pos.lbl_open_orders_help') }}</p>

      <div v-if="busy" class="text-center py-4">
        <span class="spinner-border" role="status" aria-hidden="true"></span>
      </div>

      <div v-else-if="!orders.length" class="text-center text-muted py-4">
        {{ $t('pos.lbl_no_open_orders') }}
      </div>

      <div v-else class="list-group">
        <button
          type="button"
          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center pos-tap"
          v-for="o in orders"
          :key="`ord-${o.booking_id}`"
          @click="pick(o)"
        >
          <span class="text-start">
            <strong class="d-block">{{ (o.customer && o.customer.name) || `#${o.booking_id}` }}</strong>
            <small class="text-muted">
              {{ timeLabel(o.start_date_time) }} · {{ o.items_count }} · {{ o.status }}
            </small>
          </span>
          <strong class="text-primary">{{ money(o.estimated_total) }}</strong>
        </button>
      </div>
    </PosModal>
  </span>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import AlertMessage from './AlertMessage.vue'
import PosModal from './PosModal.vue'
import { usePos } from '../../store/pos'
import { posRequest } from '../usePosRequest'
import { POS_OPEN_ORDERS, POS_ORDER_DETAIL } from '../constants/pos'
import { money } from '../money'

const store = usePos()
const { t } = useI18n()

const show = ref(false)
const busy = ref(false)
const error = ref('')
const orders = ref([])

const openModal = async () => {
  error.value = ''
  show.value = true
  await load()
}

const load = async () => {
  if (!store.branchId) return

  busy.value = true
  try {
    const res = await posRequest(POS_OPEN_ORDERS({ branch_id: store.branchId }))
    orders.value = res.ok && res.data && Array.isArray(res.data.orders) ? res.data.orders : []
    if (!res.ok) error.value = res.message || t('pos.lbl_unexpected_error')
  } finally {
    busy.value = false
  }
}

const pick = async (order) => {
  busy.value = true
  error.value = ''

  try {
    const res = await posRequest(POS_ORDER_DETAIL(order.booking_id))

    if (!res.ok || !res.data) {
      error.value = res.message || t('pos.lbl_unexpected_error')
      return
    }

    // El volcado al carrito es logica de ESTADO y vive en el store; aqui solo
    // se hace la red (mismo criterio que el resto del POS web).
    store.applyOrder(res.data)
    show.value = false
  } finally {
    busy.value = false
  }
}

/** 'Y-m-d H:i:s' -> 'H:i'. Sin parsear: evita sorpresas de zona horaria. */
const timeLabel = (raw) => (raw && raw.length >= 16 ? raw.substring(11, 16) : '')
</script>
